import { getRandomTaskId } from '@tencent/slide-sdk-model/src/utils/id-generator';

/**
 * IdGenerator 类用于生成和处理任务ID。
 */
export class IdGenerator {
    // 未通知任务ID的前缀
    public static unNoticePrefix = '10086';

    /**
     * 检查任务ID是否为未通知任务ID
     *
     * 该方法检查给定的任务ID是否以未通知任务ID的前缀开头。
     *
     * @param {number} taskId - 要检查的任务ID。
     *
     * @returns {boolean} - 如果任务ID是未通知任务ID，则返回 true；否则返回 false。
     */
    public static isUnNoticeTaskId(taskId: number): boolean {
        return taskId.toString().startsWith(IdGenerator.unNoticePrefix);
    }

    /**
     * 生成未通知任务ID
     *
     * 该方法生成一个以未通知任务ID前缀开头的随机任务ID。
     *
     * @returns {number} - 生成的未通知任务ID。
     */
    public static getUnNoticeTaskId(): number {
        return +`${IdGenerator.unNoticePrefix}${getRandomTaskId().toString()
            .slice(5)}`;
    }

    /**
     * 生成随机任务ID
     *
     * 该方法生成一个随机任务ID。
     *
     * @returns {number} - 生成的随机任务ID。
     */
    public static getTaskId(): number {
        return getRandomTaskId();
    }
}
